import { render } from "./ColorfulHeader.vue?vue&type=template&id=0d0383de"
const script = {}

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__